import { render, staticRenderFns } from "./cms-component.vue?vue&type=template&id=b01abd66&scoped=true"
import script from "./cms-component.vue?vue&type=script&lang=js"
export * from "./cms-component.vue?vue&type=script&lang=js"
import style0 from "./cms-component.vue?vue&type=style&index=0&id=b01abd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01abd66",
  null
  
)

export default component.exports